import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import FaqCore from './FaqCore.js';

var useStyles = makeStyles(function (theme) {
  return {
    mainTitle: _defineProperty({
      width: "100%",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      marginBottom: theme.spacing(6)
    }, theme.breakpoints.down("sm"), {
      marginBottom: theme.spacing(9)
    })
  };
});
var FaqBox = function FaqBox(_ref) {
  var title = _ref.title,
    elements = _ref.elements;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "left",
    alignSelf: "flex-start",
    bgcolor: "#F8F8F3",
    py: 6.25,
    pl: isExtraSmallScreen() ? 1 : 7.5,
    pr: 5.5,
    borderRadius: 16
  }, title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    component: "h2",
    className: classes.mainTitle,
    align: "left"
  }, title), elements && /*#__PURE__*/React__default.createElement(FaqCore, {
    elements: elements
  }));
};
FaqBox.propTypes = {
  title: PropTypes__default.string,
  elements: PropTypes__default.array
};

export { FaqBox as default };
//# sourceMappingURL=FaqBox.js.map
